var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "h2" }, [_vm._v("Super User Defaults")]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-12 left" }, [
            _vm.parentCorps.length
              ? _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("fg-select", {
                      attrs: {
                        label: "Select Parent Corporation",
                        list: _vm.parentCorps,
                        selectedKey: "parentAccountId"
                      },
                      model: {
                        value: _vm.selectedParentCorpId,
                        callback: function($$v) {
                          _vm.selectedParentCorpId = $$v
                        },
                        expression: "selectedParentCorpId"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _vm.subscribers.data.length && _vm.subscribers.data.length > 0
              ? _c("span", [
                  _c("strong", [
                    _vm._v(
                      "Total Super Users: " +
                        _vm._s(_vm.subscribers.data.length)
                    )
                  ]),
                  _c("br")
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-responsive text-center" },
        [
          _c(
            "l-table",
            {
              staticClass: "table table-light table-bordered table-hover",
              attrs: {
                columns: _vm.subscribers.columns,
                data: _vm.subscribers.data
              }
            },
            [
              _vm.subscribers.data.length
                ? _c(
                    "template",
                    { slot: "table-row" },
                    _vm._l(_vm.subscribers.data, function(item, index) {
                      return _c("tr", { key: index }, [
                        _c("td", [_vm._v(_vm._s(item.userId))]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(item.firstName) + " " + _vm._s(item.lastName)
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(item.email))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(item.corporationName))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(item.createdOn))]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "btn-group",
                              attrs: { role: "group" }
                            },
                            [
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip.top-center",
                                      value: _vm.tooltips.edit,
                                      expression: "tooltips.edit",
                                      modifiers: { "top-center": true }
                                    }
                                  ],
                                  staticClass: "btn btn-info btn-sm",
                                  on: {
                                    click: function($event) {
                                      return _vm.editUser(item.userId)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-edit" })]
                              )
                            ]
                          )
                        ])
                      ])
                    }),
                    0
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e2e06036", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2e06036","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/SuperAccounts.vue
// module id = g3tE
// module chunks = 0